import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

const lineReturn = { br: <br /> };

export function NotPriceable(): ReactElement {
  return (
    <div
      className="d-flex flex-column justify-content-between border-top border-bottom bg-lvl2 h-100"
      data-e2e="price-not-priceable"
    >
      <div className="d-flex justify-content-center align-items-center h-100">
        <span className="text-center fw-semibold text-secondary">
          <FormattedMessage id="flexiForwardTile.rates.NOT_PRICEABLE" values={lineReturn} />
        </span>
      </div>
    </div>
  );
}
